import script from "./ResultadosAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultadosAccordion.vue?vue&type=script&setup=true&lang=js"

import "./ResultadosAccordion.vue?vue&type=style&index=0&id=93198084&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93198084"]])

export default __exports__